import {IInsuranceProviderModel} from "../insurance-provider-model.interface";
import {BookingModel} from "../../../booking.model";
import {INeatProductRawData, INeatProviderInfoRawData, INeatQuotesRawData} from "./raw-data/neat-raw-data.interfaces";
import {NeatInsuranceProductModel} from "./product/neat-insurance-product.model";
import {
    IInsuranceProviderConfigurationViewModel
} from "../../../../../configuration/objects/insurance-configuration.interfaces";
import {
    IInsurancePaymentPageQuotesRequest
} from "../../../../../airline-webapi/requests/booking-payment-methods.request";
import {IInsuranceQuotesResponse} from "../../../../../airline-webapi/responses/insurance-quotes.response";
import {
    IProviderPaymentPageSellStrategyModel
} from "../../sell-strategies/provider-payment-page-sell-strategy.model.interface";
import {NeatPaymentPageSellStrategy} from "./strategies/payment-page/neat-payment-page-sell-strategy.model";
import {getNeatWebsitePage} from "./neat-util-functions";
import {InsuranceSellContextEnum} from "../../insurance-sell-context.enum";
import {BookingSessionStorageKeys} from "../../../storage/booking-session-storage-keys";
import {Check} from "../../../../../../types/type-checking";
import {v4 as uuidv4} from "uuid";

export class NeatInsuranceProviderModel implements IInsuranceProviderModel {

    constructor(private readonly booking: BookingModel, private readonly config: IInsuranceProviderConfigurationViewModel) {
        this._customerSessionId = booking.storage.getItem(BookingSessionStorageKeys.neatCustomerSessionId) ?? "";

        if(Check.isEmpty(this._customerSessionId)) {
            this._customerSessionId = uuidv4();
            this.booking.storage.setItem(BookingSessionStorageKeys.neatCustomerSessionId, this._customerSessionId);
        }
    }

    private readonly _customerSessionId: string;

    private get services() {
        return this.booking.services;
    }

    get providerCode(): string {
        return this.config.code.toUpperCase();
    }

    get supportsSellInPaymentPage(): boolean {
        return true;
    }



    buildPaymentPageQuotesRequest(): IInsurancePaymentPageQuotesRequest | null {
        const requestJson =  {
            website_lang: this.services.language.currentLanguageIso2,
            website_page: getNeatWebsitePage(InsuranceSellContextEnum.PaymentPage),
            customer_session_id: this._customerSessionId,
            customer_channel: this.services.layout.shouldUseWebappLayout ? "WEBSITE" : "MOBILE_APP"
        }
        return {
            providerCode: this.providerCode,
            requestJson: JSON.stringify(requestJson),
        }
    }

    createPaymentPageSellStrategy(quotes: IInsuranceQuotesResponse): IProviderPaymentPageSellStrategyModel | null {
        try {
            const quotesJson: INeatQuotesRawData = JSON.parse(quotes.quotesJson);
            const providerInfoJson: INeatProviderInfoRawData = JSON.parse(quotes.providerInfoJson);


            const productsModels = this._buildProductModels(quotesJson?.products);

            if(productsModels.length === 0) {
                return null;
            }

            return new NeatPaymentPageSellStrategy(this.providerCode, this.booking, productsModels, providerInfoJson, this._customerSessionId);

        } catch (err) {
            this.services.logger.error(`Failed to parse quotes for provider ${this.providerCode}`, err);
            return null;
        }

    }


    private _buildProductModels(productsRawData: INeatProductRawData[]): NeatInsuranceProductModel[] {
        productsRawData = productsRawData ?? [];

        if(productsRawData.length === 0) {
            return [];
        }

        if(!this.config?.products) {
            return [];
        }

        if(this.config.products.length === 0) {
            return [];
        }

        const result: NeatInsuranceProductModel[] = [];
        for(const productRawData of productsRawData) {
            const productConfig = this.config.products.find(productCfg => productRawData.technical_name.toUpperCase() === productCfg.code.toUpperCase());
            if(productConfig && productRawData.premium_display > 0) {
                result.push(new NeatInsuranceProductModel(this.booking, this.providerCode, productRawData, productConfig));
            }

        }
        return result;
    }

}


